/**
 * @generated SignedSource<<a59a7d48f2a2606e09e70499bb1b3044>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Permission = "canCreateAnnouncement" | "canCreateContent" | "canCreateEvent" | "canCreateFolderIn" | "canCreateFolderInRoot" | "canCreateItemIn" | "canCreateItemInRoot" | "%future added value";
export type SpaceRole = "SPACE_MEMBERS" | "%future added value";
export type PermissionsUpdatePermissionsMutationInput = {
  allowMemberIds?: ReadonlyArray<string> | null;
  allowRoles?: ReadonlyArray<SpaceRole> | null;
  clientMutationId?: string | null;
  nodeId: string;
  revokeAllMembers?: boolean | null;
  revokeMemberIds?: ReadonlyArray<string> | null;
  revokeRoles?: ReadonlyArray<SpaceRole> | null;
  rule: Permission;
};
export type PermissionRuleUpdateModal_updateNodePermissions_Mutation$variables = {
  input: PermissionsUpdatePermissionsMutationInput;
};
export type PermissionRuleUpdateModal_updateNodePermissions_Mutation$data = {
  readonly updateNodePermissions: {
    readonly node: {
      readonly " $fragmentSpreads": FragmentRefs<"PermissionRules_node" | "SpaceAnnouncementsModulePermissionRules_module" | "SpaceEventsModulePermissionRules_module" | "SpaceFilesModulePermissionRules_module">;
    };
  } | null;
};
export type PermissionRuleUpdateModal_updateNodePermissions_Mutation = {
  response: PermissionRuleUpdateModal_updateNodePermissions_Mutation$data;
  variables: PermissionRuleUpdateModal_updateNodePermissions_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  (v3/*: any*/)
],
v5 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
],
v6 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "allowedRoles",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "MemberConnection",
    "kind": "LinkedField",
    "name": "allowedMembers",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MemberEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Member",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": "avatar",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "width",
                    "value": 750
                  }
                ],
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "image",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  }
                ],
                "storageKey": "image(width:750)"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "roles",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Genealogy__Person",
                "kind": "LinkedField",
                "name": "genealogyPerson",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": (v5/*: any*/),
                    "type": "MemberDeletedStatus",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v7 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PermissionRule",
    "kind": "LinkedField",
    "name": "canCreateFolderInRoot",
    "plural": false,
    "selections": (v6/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "PermissionRule",
    "kind": "LinkedField",
    "name": "canCreateItemInRoot",
    "plural": false,
    "selections": (v6/*: any*/),
    "storageKey": null
  }
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "ownershipSpace",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v9 = [
  (v2/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "mimeType",
        "storageKey": null
      }
    ],
    "type": "File",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": (v4/*: any*/),
    "type": "Node",
    "abstractKey": "__isNode"
  },
  {
    "kind": "InlineFragment",
    "selections": (v4/*: any*/),
    "type": "PendingFile",
    "abstractKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PermissionRuleUpdateModal_updateNodePermissions_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PermissionsUpdatePermissionsMutationPayload",
        "kind": "LinkedField",
        "name": "updateNodePermissions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SpaceEventsModulePermissionRules_module"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SpaceAnnouncementsModulePermissionRules_module"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SpaceFilesModulePermissionRules_module"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PermissionRules_node"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PermissionRuleUpdateModal_updateNodePermissions_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PermissionsUpdatePermissionsMutationPayload",
        "kind": "LinkedField",
        "name": "updateNodePermissions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isNode"
              },
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventModulePermissionConfig",
                    "kind": "LinkedField",
                    "name": "permissionConfig",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PermissionRule",
                        "kind": "LinkedField",
                        "name": "canCreateEvent",
                        "plural": false,
                        "selections": (v6/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "SpaceEventsModule",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AnnouncementModulePermissionConfig",
                    "kind": "LinkedField",
                    "name": "permissionConfig",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PermissionRule",
                        "kind": "LinkedField",
                        "name": "canCreateAnnouncement",
                        "plural": false,
                        "selections": (v6/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "SpaceAnnouncementsModule",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FileModulePermissionConfig",
                    "kind": "LinkedField",
                    "name": "permissionConfig",
                    "plural": false,
                    "selections": (v7/*: any*/),
                    "storageKey": null
                  }
                ],
                "type": "SpaceFilesModule",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": "isEvent",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AuthorizationResult",
                    "kind": "LinkedField",
                    "name": "canUpdate",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CalendarEventPermissionConfig",
                    "kind": "LinkedField",
                    "name": "permissionConfig",
                    "plural": false,
                    "selections": (v7/*: any*/),
                    "storageKey": null
                  }
                ],
                "type": "Event",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": "isFolder",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AuthorizationResult",
                    "kind": "LinkedField",
                    "name": "canModifyOwners",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  {
                    "alias": "folderPermissions",
                    "args": null,
                    "concreteType": "FolderNodePermissionConfig",
                    "kind": "LinkedField",
                    "name": "permissionConfig",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PermissionRule",
                        "kind": "LinkedField",
                        "name": "canCreateFolderIn",
                        "plural": false,
                        "selections": (v6/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PermissionRule",
                        "kind": "LinkedField",
                        "name": "canCreateItemIn",
                        "plural": false,
                        "selections": (v6/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "Folder",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AuthorizationResult",
                    "kind": "LinkedField",
                    "name": "canUpdateSecurity",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "preventDownload",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasWatermark",
                    "storageKey": null
                  }
                ],
                "type": "HasNodeSecurityInterface",
                "abstractKey": "__isHasNodeSecurityInterface"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": "folderItemContent",
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": (v9/*: any*/),
                    "storageKey": null
                  }
                ],
                "type": "FolderItem",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": "vaultItemContent",
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": (v9/*: any*/),
                    "storageKey": null
                  }
                ],
                "type": "VaultItem",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": "draftVaultItemContent",
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": (v9/*: any*/),
                    "storageKey": null
                  }
                ],
                "type": "VaultDraftItem",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": "announcementAttachmentContent",
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": (v9/*: any*/),
                    "storageKey": null
                  }
                ],
                "type": "AnnouncementAttachment",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c609c4575fb65e4e56690c0b53c7418f",
    "id": null,
    "metadata": {},
    "name": "PermissionRuleUpdateModal_updateNodePermissions_Mutation",
    "operationKind": "mutation",
    "text": "mutation PermissionRuleUpdateModal_updateNodePermissions_Mutation(\n  $input: PermissionsUpdatePermissionsMutationInput!\n) {\n  updateNodePermissions(input: $input) {\n    node {\n      __typename\n      ...SpaceEventsModulePermissionRules_module\n      ...SpaceAnnouncementsModulePermissionRules_module\n      ...SpaceFilesModulePermissionRules_module\n      ...PermissionRules_node\n      id\n    }\n  }\n}\n\nfragment EventPermissionRules_event on Event {\n  id\n  canUpdate {\n    value\n  }\n  ownershipSpace {\n    id\n  }\n  permissionConfig {\n    canCreateFolderInRoot {\n      allowedRoles\n      allowedMembers {\n        edges {\n          node {\n            id\n            name\n            avatar: image(width: 750) {\n              url\n            }\n            ...UserHandle_member\n          }\n        }\n      }\n    }\n    canCreateItemInRoot {\n      allowedRoles\n      allowedMembers {\n        edges {\n          node {\n            id\n            name\n            avatar: image(width: 750) {\n              url\n            }\n            ...UserHandle_member\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment FolderPermissionRules_folder on Folder {\n  id\n  canModifyOwners {\n    value\n  }\n  ownershipSpace {\n    id\n  }\n  folderPermissions: permissionConfig {\n    canCreateFolderIn {\n      allowedRoles\n      allowedMembers {\n        edges {\n          node {\n            id\n            name\n            avatar: image(width: 750) {\n              url\n            }\n            ...UserHandle_member\n          }\n        }\n      }\n    }\n    canCreateItemIn {\n      allowedRoles\n      allowedMembers {\n        edges {\n          node {\n            id\n            name\n            avatar: image(width: 750) {\n              url\n            }\n            ...UserHandle_member\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment PermissionRules_node on Node {\n  __isNode: __typename\n  ... on Event {\n    isEvent: __typename\n    ...EventPermissionRules_event\n  }\n  ... on Folder {\n    isFolder: __typename\n    ...FolderPermissionRules_folder\n  }\n  ...useNodeSecurity_node\n}\n\nfragment SpaceAnnouncementsModulePermissionRules_module on SpaceAnnouncementsModule {\n  id\n  permissionConfig {\n    canCreateAnnouncement {\n      allowedRoles\n      allowedMembers {\n        edges {\n          node {\n            id\n            name\n            avatar: image(width: 750) {\n              url\n            }\n            ...UserHandle_member\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment SpaceEventsModulePermissionRules_module on SpaceEventsModule {\n  id\n  permissionConfig {\n    canCreateEvent {\n      allowedRoles\n      allowedMembers {\n        edges {\n          node {\n            id\n            name\n            avatar: image(width: 750) {\n              url\n            }\n            ...UserHandle_member\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment SpaceFilesModulePermissionRules_module on SpaceFilesModule {\n  id\n  permissionConfig {\n    canCreateFolderInRoot {\n      allowedRoles\n      allowedMembers {\n        edges {\n          node {\n            id\n            name\n            avatar: image(width: 750) {\n              url\n            }\n            ...UserHandle_member\n          }\n        }\n      }\n    }\n    canCreateItemInRoot {\n      allowedRoles\n      allowedMembers {\n        edges {\n          node {\n            id\n            name\n            avatar: image(width: 750) {\n              url\n            }\n            ...UserHandle_member\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment UserAvatar_member on Member {\n  name\n  email\n  avatar: image(width: 750) {\n    url\n  }\n}\n\nfragment UserHandle_member on Member {\n  id\n  name\n  email\n  ...UserAvatar_member\n  ...UserInfoPopover_member\n}\n\nfragment UserInfoPopover_member on Member {\n  id\n  name\n  email\n  roles\n  ...UserAvatar_member\n  genealogyPerson {\n    id\n  }\n  status {\n    __typename\n    ... on MemberDeletedStatus {\n      value\n    }\n  }\n}\n\nfragment useNodeSecurity_node on Node {\n  __isNode: __typename\n  id\n  ... on HasNodeSecurityInterface {\n    __isHasNodeSecurityInterface: __typename\n    canUpdateSecurity {\n      value\n    }\n    preventDownload\n    hasWatermark\n  }\n  ... on FolderItem {\n    folderItemContent: content {\n      __typename\n      ... on File {\n        mimeType\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n  ... on VaultItem {\n    vaultItemContent: content {\n      __typename\n      ... on File {\n        mimeType\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n  ... on VaultDraftItem {\n    draftVaultItemContent: content {\n      __typename\n      ... on File {\n        mimeType\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n  ... on AnnouncementAttachment {\n    announcementAttachmentContent: content {\n      __typename\n      ... on File {\n        mimeType\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0d122a81fec257ef6e0fd4846e651f6b";

export default node;
